import { render } from "./MoleculeCarrousel.vue?vue&type=template&id=4c31b88e&scoped=true&ts=true"
import script from "./MoleculeCarrousel.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeCarrousel.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeCarrousel.vue?vue&type=style&index=0&id=4c31b88e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c31b88e"],['__file',"src/components/molecules/MoleculeCarrousel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c31b88e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c31b88e', __exports__)) {
    api.reload('4c31b88e', __exports__)
  }
  
  module.hot.accept("./MoleculeCarrousel.vue?vue&type=template&id=4c31b88e&scoped=true&ts=true", () => {
    api.rerender('4c31b88e', render)
  })

}


export default __exports__